import "./counter.css.ts.vanilla.mjs";
var t = "p273__counter-65cd_fc019d8f6__5b6p60";
export {
  t as counterStyle
};
//# sourceMappingURL=counter.mjs.map
